import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useNoteEntityRelationshipStyles = makeStyles<Theme>(() => ({
  root: {
    padding: '8px',
    color: 'grey',
    borderRadius: '5px',
    border: '0.5px solid rgba(224, 224, 224, 1)',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: 'rgba(245, 245, 245, 1)'
    }
  },
  icon: {
    padding: '5px',
    color: 'black'
  },
  status: {
    padding: '5px',
    color: 'white',
    borderRadius: '8px'
  },
  id: {
    padding: '5px'
  }
}));
